var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAndBrandingGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#B2B2B2;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st1{display:none;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 175.4,
    y1: 71.6,
    x2: 175.4,
    y2: 1008.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 321.2,
    y1: 71.6,
    x2: 321.2,
    y2: 1008.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 467.1,
    y1: 71.6,
    x2: 467.1,
    y2: 1008.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 612.9,
    y1: 71.6,
    x2: 612.9,
    y2: 1008.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 758.8,
    y1: 71.6,
    x2: 758.8,
    y2: 1008.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 904.6,
    y1: 71.6,
    x2: 904.6,
    y2: 1008.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1008.4,
    y1: 175.4,
    x2: 71.6,
    y2: 175.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1008.4,
    y1: 321.2,
    x2: 71.6,
    y2: 321.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1008.4,
    y1: 467.1,
    x2: 71.6,
    y2: 467.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1008.4,
    y1: 612.9,
    x2: 71.6,
    y2: 612.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1008.4,
    y1: 758.8,
    x2: 71.6,
    y2: 758.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1008.4,
    y1: 904.6,
    x2: 71.6,
    y2: 904.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M540,131.3L320.5,574.3l109.2,142.8c13.3,17.4,20.5,38.7,20.5,60.6v163.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M540,131.3l219.5,443.1L650.3,717.1c-13.3,17.4-20.5,38.7-20.5,60.6v163.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 540,
    y1: 99.3,
    x2: 540,
    y2: 582.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 572.3,
    r: 36.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 392.3,
    y1: 841.8,
    x2: 685.7,
    y2: 841.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.1,
    y: 841.8,
    width: 127.7,
    height: 99.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAndBrandingGrid);
export default __webpack_public_path__ + "static/media/Logo-and-Branding-Grid.cdaff74c3e260332b02202d01550d17c.svg";
export { ForwardRef as ReactComponent };